import { useCallback, useEffect, useRef, useState } from "react";
import { config } from "../Constants";
import useAuth from "../context/AuthProvider";
import React from "react";
import { TaxTransactionReportModel, TaxTransactionReportModel_Resp } from "../models/TaxTransactionReportModel";
import { Box, Stack, width } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button, Chip, FormControl, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, Select, SelectChangeEvent, SelectProps, TextField, Switch, Tabs, Tab } from "@mui/material";
// import { Chip, FormControl, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, Select, SelectChangeEvent, SelectProps, TextField, Switch } from "@mui/material";
import { writeXlsxFile, formatUtcToLocal } from "../helper/utils";
//import { FieldAttributes, useField, useFormikContext } from "formik";
import { Field, FieldArray, FieldAttributes, Form, Formik, useField, useFormik, useFormikContext } from 'formik';
import CancelIcon from "@mui/icons-material/Cancel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DiligentSearchList, FMFilters, DiligentTabs } from "../components/Lists/DiligentSearchList";
import Swal from "sweetalert2";
import DiligentMarkCompleted from "./DiligentMarkCompleted";
import moment from "moment";
import { apiClient } from "../helper/api";
import { GridFilterModel, GridSortModel } from "@mui/x-data-grid-pro";
import { FileDownload, CheckCircle } from "@mui/icons-material";

interface ModelForFilters {
    completedPage?: boolean;
    homeState?: string,
    insuredName?: string,
    policyNumber?: string,
    invoiceNumber?: string,
    needDiligentSearch?: string,
    diligentSearchNotes?: string,
    suspended?: string,
    transactionType?: string
    carrier?: string,
    naic?: string,
    invDate?: string,
    policyEffDate?: string,
    policyExpDate?: string,
    grossPremium?: string,
    client?: string,
    diligentSearchCompleted?: string,
    pageSize?: number;
    pageNumber?: number; 
    field?: string; 
    sort?: string;
    customerIds?: string;
    dateCompleted?: string;
    
    // Month/Year filtering properties
    month?: string;
    year?: string;
}

export const DiligentSearch = () => {

    const { user } = useAuth();
    const token = user?.token;
    const [loading, setloading] = useState(false);

    const initValue: TaxTransactionReportModel_Resp = {
        getOutstandingFilingsReport_Respdata: [],
        totalCount: 0,
        needDiligentSearch: undefined,
        diligentSearchCompleted: undefined,
        dateCompleted: undefined
    }

    const [ReportModule, setReportModule] = useState<TaxTransactionReportModel_Resp>(initValue)
    const [tabValue, setTabValue] = useState<DiligentTabs>(DiligentTabs.OpenDiligent)
    const [selectedRows, setSelectedRows] = useState<TaxTransactionReportModel[]>()
    const [openCompletedDialog, setOpenCompletedDialog] = useState<string>('')
    const [_currentPage, setCurrentPage] = React.useState(1)
    const [_pageSize, setPageSize] = React.useState(50)
    
    const sortRef = useRef<GridSortModel>([])
    const filterRef = useRef<GridFilterModel>()
    const customersRef = useRef<string[]>([])
    const [selectedCustomers, setSelectedCustomers] = React.useState<string[] | string>([]);
    
    // Removed month/year state variables - only using customer filtering for main page
    
    // Monthly export state variables (admin-only)
    const monthRef = useRef<string>((new Date().getMonth() + 1).toString());
    const yearRef = useRef<string>(new Date().getFullYear().toString());

    const keysNamesFromXlsx = [
        'HomeState', 'InsuredName', 'PolicyNumber', 'InvoiceNumber',
        'TransactionType', 'Carrier', 'NAIC', 'InvoiceDate', 'PolicyEffDate', 'PolicyExpDate',
        'GrossPremium','Client', 'DiligentSearchToGMAC', 'Suspended', 'NeedDiligentSearch', 'DiligentSearchNotes',
        'DiligentSearchCompleted', 'DateCompleted'
    ]

    // const keyNames: (keyof TaxTransactionReportModel)[] = [
    //     'homeState', 'insuredName', 'policyNumber', 'invoiceNumber',
    //     'transactionType', 'carrier', 'naic', 'invDate', 'policyEffDate', 'policyExpDate', 
    //     'grossPremium', 'client', 'diligentSearchToGmac', 'suspended', 'needDiligentSearch', 'diligentSearchNotes',
    //     'diligentSearchCompleted', 'dateCompleted'
    // ]

    const handleOpenCompletedDialog = (status: string) => {
        setOpenCompletedDialog(status);
    };

    const handleCloseCompletedDialog = () => {
        setOpenCompletedDialog('');
    };

    // Monthly export handlers (admin-only)
    const handleExportMonthChange = (event: SelectChangeEvent<string>) => {
        monthRef.current = event.target.value;
        fetchNewData(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current);
    };

    const handleExportYearChange = (event: SelectChangeEvent<string>) => {
        yearRef.current = event.target.value;

        fetchNewData(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current);
    };

    // Trigger data fetch when tab changes
    useEffect(() => {
        fetchNewData(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current);
    }, [tabValue]);

    
    const handleSubmitCompletedDialog = (completedDate: string) => {
        setOpenCompletedDialog('');
        setloading(true);
        var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId) ?? [];
        var Ids = customerPolicyIds.join(',')
        apiClient(`/DiligentSearch/updateDiligentSearchCompleted?dateCompleted=${completedDate}&ids=${Ids}`, {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }),
        })
        .then((res) => {
            if (!res) return
            setSelectedRows([]);
            Swal.fire({
                title: "Successful!",
                text: "Success",
                icon: "success",
                confirmButtonText: "OK",
            })

            fetchNewData(_pageSize, _currentPage, tabValue);
            setloading(false);
        })
        .finally(() => {
            setloading(false);
        });
        

    };
    
    const buildDiligentFilterPayload = (
        pageSize: number,
        pageNumber: number,
        selectedTab: DiligentTabs,
        newFilters?: GridFilterModel,
        newSort?: GridSortModel
    ): ModelForFilters => {
        const selectedCustomerIds = Array.isArray(customersRef.current) ? customersRef.current : [customersRef.current]
        const customerIds = selectedCustomerIds.join(",")
        const initFilterModel: ModelForFilters = {}
        initFilterModel.completedPage = selectedTab === DiligentTabs.CompletedDiligent
        initFilterModel.pageNumber = pageNumber
        initFilterModel.customerIds = customerIds
        initFilterModel.pageSize = pageSize
        if (newSort) {
            initFilterModel.field = newSort[0]?.field ?? ""
            initFilterModel.sort = newSort[0]?.sort ?? ""
        }

        initFilterModel.homeState = newFilters?.items.find((m) => m.columnField === "homeState")?.value
        initFilterModel.insuredName = newFilters?.items.find((m) => m.columnField === "insuredName")?.value
        initFilterModel.policyNumber = newFilters?.items.find((m) => m.columnField === "policyNumber")?.value
        initFilterModel.invoiceNumber = newFilters?.items.find((m) => m.columnField === "invoiceNumber")?.value
        initFilterModel.needDiligentSearch = newFilters?.items.find((m) => m.columnField === "needDiligentSearch")?.value
        initFilterModel.diligentSearchNotes = newFilters?.items.find((m) => m.columnField === "diligentSearchNotes")?.value
        initFilterModel.suspended = newFilters?.items.find((m) => m.columnField === "suspended")?.value
        initFilterModel.transactionType = newFilters?.items.find((m) => m.columnField === "transactionType")?.value
        initFilterModel.carrier = newFilters?.items.find((m) => m.columnField === "carrier")?.value
        initFilterModel.naic = newFilters?.items.find((m) => m.columnField === "naic")?.value
        initFilterModel.invDate = newFilters?.items.find((m) => m.columnField === "invDate")?.value
        initFilterModel.policyEffDate = newFilters?.items.find((m) => m.columnField === "policyEffDate")?.value
        initFilterModel.policyExpDate = newFilters?.items.find((m) => m.columnField === "policyExpDate")?.value
        initFilterModel.grossPremium = newFilters?.items.find((m) => m.columnField === "grossPremium")?.value
        initFilterModel.client = newFilters?.items.find((m) => m.columnField === "client")?.value
        initFilterModel.diligentSearchCompleted = newFilters?.items.find((m) => m.columnField === "diligentSearchCompleted")?.value
        initFilterModel.dateCompleted = newFilters?.items.find((m) => m.columnField === "dateCompleted")?.value
        initFilterModel.month = monthRef.current
        initFilterModel.year = yearRef.current
        return initFilterModel
    }

    const postDiligentSearchFilteredData = async (
        initFilterModel: ModelForFilters
    ): Promise<TaxTransactionReportModel_Resp> => {
        const responseJson = await apiClient(`/DiligentSearch/getDiligentSearchFilteredData`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(initFilterModel),
        })
        if (!responseJson) return initValue
        if (responseJson.data != null && responseJson.data.totalCount > 0) {
            return responseJson.data as TaxTransactionReportModel_Resp
        }
        return initValue
    }

    const getDiligentData = async (
        pageSize: number,
        pageNumber: number,
        selectedTab: DiligentTabs,
        newFilters?: GridFilterModel,
        newSort?: GridSortModel
    ) => {
        setloading(true)
        try {
            const payload = buildDiligentFilterPayload(pageSize, pageNumber, selectedTab, newFilters, newSort)
            return await postDiligentSearchFilteredData(payload)
        } finally {
            setloading(false)
        }
    }

    /** All pages for toolbar Excel export (same filters/sort/tab as the grid). */
    const fetchAllDiligentSearchRowsForExport = useCallback(async (): Promise<TaxTransactionReportModel[]> => {
        const exportPageSize = 500
        const maxPages = 500
        const acc: TaxTransactionReportModel[] = []
        let page = 1
        let totalCount = 0
        while (page <= maxPages) {
            const payload = buildDiligentFilterPayload(
                exportPageSize,
                page,
                tabValue,
                filterRef.current,
                sortRef.current
            )
            const data = await postDiligentSearchFilteredData(payload)
            const batch = data.getOutstandingFilingsReport_Respdata ?? []
            if (page === 1) {
                totalCount = Number(data.totalCount) || 0
            }
            if (!batch.length) break
            acc.push(...batch)
            if (totalCount > 0 && acc.length >= totalCount) break
            if (batch.length < exportPageSize) break
            page++
        }
        return acc
    }, [token, tabValue])
    const fetchNewData = async(pageSize: number, pageNumber: number, selectedTab: DiligentTabs, newFilters?: GridFilterModel, newSort?: GridSortModel) => {
        const res = await getDiligentData(
            pageSize,
            pageNumber,
            selectedTab,
            newFilters,
            newSort
        )
        setReportModule(res)
    }

    const handleTabChange = (tab: DiligentTabs) => {
        // setCompletedPage(tab == 2)
        setloading(true);
        setTabValue(tab);
        setPageSize(50);
        setCurrentPage(1);
        fetchNewData(50, 1, tab);
    };

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    // const onExportXlsx = (values: TaxTransactionReportModel[]) => {
    //     setloading(true);
    //     if (values.length === 0) {
    //         return
    //     }
    //     let filteredKeyNames = keyNames;
    //     if (tabValue === DiligentTabs.OpenDiligent) {
    //         filteredKeyNames = keyNames.filter(key => key !== 'dateCompleted' && key !== 'diligentSearchCompleted');
    //     }
    //     const items = values.map(item => {
    //         const update: (string | number | Date | undefined)[] = [];
    
    //         filteredKeyNames.map((key: keyof TaxTransactionReportModel) => {
    //             if (key === 'dateCompleted') {
    //                 update.push(formatUtcToLocal(item[key], "MM/DD/YYYY"));
    //             } else {
    //                 update.push(item[key]);
    //             }
    //         });
    
    //         return update;
    //     });
    //     const updates = [
    //         filteredKeyNames,
    //         ...items
    //     ]
    //     writeXlsxFile(updates)
    //     setloading(false);
    // }
   
    const handleExportXlsxNew = async (val: TaxTransactionReportModel[]) => {
        try {
            setloading(true);

            // Show loading dialog
            Swal.fire({
                title: 'Generating Excel...',
                text: 'Please wait while we generate your Diligent Search Excel file.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Prepare simplified request payload for the new API endpoint
            const selectedCustomerIds = Array.isArray(customersRef.current) ? customersRef.current : [customersRef.current];
            const partnerId = selectedCustomerIds.length > 0 ? parseInt(selectedCustomerIds[0]) : 127; // Default to 127 if no customer selected
            
            // Get the actual partner name from the customer data
            const selectedCustomer = Customer.find(customer => customer.partnersId === partnerId);
            const partnerName = selectedCustomer ? selectedCustomer.customerName : "Default Partner";

            const requestPayload = {
                partnerId: partnerId,
                clientName: partnerName,
                userTimezone: 'America/Denver'
            };

            console.log('🔍 DILIGENT SEARCH EXCEL EXPORT REQUEST:', requestPayload);

            const response = await apiClient('/MonthEndBilling/generate-diligent-search-internal-excel', {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(requestPayload),
            });

            Swal.close();

            console.log('📥 DILIGENT SEARCH EXCEL EXPORT RESPONSE:', response);

            if (response && response.status === true && response.data && response.data.excel_url) {
                // Success - download the Excel file
                const link = document.createElement('a');
                link.href = response.data.excel_url;
                link.download = response.data.filename || 'diligent_search_export.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                Swal.fire({
                    icon: 'success',
                    title: 'Excel Generated Successfully!',
                    text: `File: ${response.data.filename} (${response.data.original_data_count} records)`,
                    confirmButtonText: 'OK'
                });
            } else {
                // Handle failure cases
                const errorMessage = response?.message || 'Failed to generate Excel file';
                Swal.fire({
                    icon: 'error',
                    title: 'Export Failed',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }

            setSelectedRows([]);
            setloading(false);
        } catch (error) {
            console.error('Error in handleExportXlsxNew:', error);
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Export Failed',
                text: 'An error occurred while generating the Excel file.',
                confirmButtonText: 'OK'
            });
            setloading(false);
        }
    }

    // Monthly export function (admin-only)
    const handleMonthlyExport = async () => {
        try {
            // Get selected customer IDs
            const selectedCustomerIds = Array.isArray(customersRef.current) ? customersRef.current : [customersRef.current];
            
            // Validation: Ensure exactly one customer is selected
            if (!selectedCustomerIds || selectedCustomerIds.length === 0 || selectedCustomerIds[0] === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'No Customer Selected',
                    text: 'Please select a customer before exporting the monthly report.',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK'
                });
                return;
            }
            
            if (selectedCustomerIds.length > 1) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Multiple Customers Selected',
                    text: 'Please select only ONE customer for the monthly export.',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK'
                });
                return;
            }

            setloading(true);

            // Show loading dialog
            Swal.fire({
                title: 'Generating Monthly Report...',
                text: 'Please wait while we generate your monthly Diligent Search report.',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            const partnerId = selectedCustomerIds.length > 0 ? parseInt(selectedCustomerIds[0]) : 127; // Default to 127 if no customer selected
            
            // Get the actual partner name from the customer data
            const selectedCustomer = Customer.find(customer => customer.partnersId === partnerId);
            const partnerName = selectedCustomer ? selectedCustomer.customerName : "Default Partner";

            const requestPayload = {
                partnerId: partnerId,
                month: parseInt(monthRef.current),
                year: parseInt(yearRef.current),
                clientName: partnerName,
                userTimezone: 'America/Denver'
            };

            console.log('🔍 MONTHLY DILIGENT SEARCH EXPORT REQUEST:', requestPayload);

            const response = await apiClient('/MonthEndBilling/generate-diligent-search-internal-excel', {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(requestPayload),
            });

            Swal.close();

            if (response && response.status && response.data && response.data.excel_url) {
                // Download the Excel file
                const link = document.createElement('a');
                link.href = response.data.excel_url;
                link.download = response.data.filename || `diligent_search_monthly_${monthRef.current}_${yearRef.current}.xlsx`;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Show success message
                Swal.fire({
                    title: 'Success!',
                    text: `Monthly report for ${monthRef.current}/${yearRef.current} downloaded successfully! ${response.data.original_data_count || 0} records processed.`,
                    icon: 'success',
                    confirmButtonColor: '#02A4E3',
                    timer: 3000,
                    timerProgressBar: true
                });
            } else {
                // API returned an error or invalid response
                const errorMessage = response?.message || response?.error || response?.data?.message || 'Invalid response from server';
                Swal.fire({
                    icon: 'error',
                    title: 'Export Failed',
                    text: errorMessage,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#02A4E3'
                });
            }

            setloading(false);
        } catch (error: any) {
            console.error('Error in handleMonthlyExport:', error);
            Swal.close();
            
            // Extract error message from the error object
            let errorMessage = 'An error occurred while generating the monthly report.';
            
            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error?.message) {
                errorMessage = error.message;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }
            
            Swal.fire({
                icon: 'error',
                title: 'Export Failed',
                text: errorMessage,
                confirmButtonText: 'OK',
                confirmButtonColor: '#02A4E3'
            });
            setloading(false);
        }
    }

    const handleCustomersChange = async (e: string) => {
        var result = selectedCustomers.toLocaleString().split(',').filter((item) => item !== e);
        setSelectedCustomers(result);
        onChangeCustomer(result);
    }

    async function onChangeCustomer(customers: string | string[]) {
        const selectedCustomerIds = Array.isArray(customers) ? customers : [customers]
        customersRef.current = selectedCustomerIds
        fetchNewData(_pageSize, _currentPage, tabValue, filterRef.current, sortRef.current);
    }
    const initialUserdata = { partnersId: 0, customerName: "" };
    const [Customer, setCustomer] = useState([initialUserdata]);
    const fetchCustomer = () => {
        apiClient("/DiligentSearch/getPartnersByDiligent", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (!responseJson) return
                setCustomer(responseJson.data);
            })
    };

    const FMSelectCustomer: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {

        return (
            <FormControl fullWidth sx={{}}  >
                <InputLabel id="State-Select-Label" sx={{ transform: 'translate(14px, 11px) scale(1)', '&.MuiInputLabel-shrink': { transform: 'translate(18px, -5px) scale(0.75)' } }}>Customers</InputLabel>
                <Select
                    // {...field}
                    disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                    label={"Customers"}
                    sx={{
                        borderRadius: '8px',
                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#0000003b' },
                        '& .MuiSelect-select': { padding: '8.5px 16px' },
                    }}
                    // className="border-round main-form-2"
                    multiple
                    labelId="State-Select-Label"
                    value={selectedCustomers}
                    IconComponent={ExpandMoreIcon}
                    onChange={(e) => {
                        const selectedValues = e.target.value;
                        setSelectedCustomers(selectedValues);
                        onChangeCustomer(selectedValues);
                    }}
                    renderValue={(selected) => (
                        <Stack gap={1} direction="row" flexWrap="wrap">
                            {selected.toLocaleString().split(',').map((value) => (
                                <Chip

                                    key={value}
                                    label={Customer.find(x => x.partnersId.toString() === value)?.customerName}
                                    onDelete={() =>
                                        handleCustomersChange(value)
                                    }
                                    disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                                    deleteIcon={
                                        <CancelIcon
                                            onMouseDown={(event) => event.stopPropagation()}
                                        />
                                    }
                                />
                            ))}

                        </Stack>
                    )}
                >
                    {Customer.map((Cust, key) =>
                        <MenuItem key={key} value={Cust.partnersId}>  {Cust.customerName} </MenuItem>
                    )}
                </Select>
            </FormControl>
        )
    }

    useEffect(() => {
        fetchNewData(50, 1, tabValue);
        fetchCustomer();
    }, [])

    const handleMarkCompleted = () => {
        handleOpenCompletedDialog('true');
    }
    return (
        <><LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
                <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
                    {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
                </div>
            </Box>
            {/* Top bar: Tabs | Filters toggle | Action buttons */}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 1.5,
                    px: 2,
                    py: 1.5,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 56,
                    // mb: 3,
                    marginLeft: { xs: '-24px', md: '0px' },
                    marginRight: { xs: '-24px', md: '0px' },
                }}
            >
                {/* Tabs: desktop only (md and up) */}
                <Tabs
                    value={tabValue}
                    onChange={(_, newValue) => handleTabChange(newValue)}
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        minHeight: 48,
                        '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: '0.9375rem' },
                        '& .Mui-selected': { color: '#2099d2' },
                        '& .MuiTabs-indicator': { backgroundColor: '#2099d2', height: 3, borderRadius: '3px 3px 0 0' },
                    }}
                >
                    <Tab value={DiligentTabs.OpenDiligent} label="Open Diligent Searches" />
                    <Tab value={DiligentTabs.CompletedDiligent} label="Completed Diligent Searches" />
                </Tabs>
                {/* Select option for mobile/tablet view */}
                <FormControl
                    size="small"
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        minWidth: 160,
                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
                        '& .MuiSelect-select': { fontWeight: 600, color: '#2099d2', py: 0.9 },
                    }}
                >
                    <Select
                        value={tabValue}
                        onChange={(e) => handleTabChange(Number(e.target.value) as DiligentTabs)}
                        displayEmpty
                        sx={{ textTransform: 'none', fontSize: '0.9375rem' }}
                    >
                        <MenuItem value={DiligentTabs.OpenDiligent}>Open Diligent Searches</MenuItem>
                        <MenuItem value={DiligentTabs.CompletedDiligent}>Completed Diligent Searches</MenuItem>
                    </Select>
                </FormControl>

                <Box sx={{ flex: 1, minWidth: 120 }} />

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                    {tabValue === DiligentTabs.OpenDiligent && selectedRows && selectedRows.length > 0 && (
                        <Button
                            variant="contained"
                            size="medium"
                            onClick={handleMarkCompleted}
                            startIcon={<CheckCircle />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#10b981',
                                '&:hover': { backgroundColor: '#059669' },
                                px: 2,
                            }}
                        >
                            Mark Completed
                        </Button>
                    )}
                    {/* <Button
                        variant="contained"
                        size="medium"
                        onClick={() => onExportXlsx(ReportModule.getOutstandingFilingsReport_Respdata || [])}
                        startIcon={<FileDownload />}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            backgroundColor: '#2099d2',
                            '&:hover': { backgroundColor: '#176990' },
                            px: 2,
                        }}
                    >
                        Export
                    </Button> */}
                    {(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer")) && (
                        <Button
                            variant="outlined"
                            size="medium"
                            onClick={handleMonthlyExport}
                            startIcon={<FileDownload />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                borderColor: '#e2e8f0',
                                color: '#475569',
                                '&:hover': {
                                    borderColor: '#2099d2',
                                    backgroundColor: '#2099d214',
                                    color: '#2099d2',
                                },
                                px: 2,
                            }}
                        >
                            Export Monthly
                        </Button>
                    )}
                </Box>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    py: 2,
                    px: 2,
                }}
            >
                <Grid container spacing={2} alignItems="center">
                        <Grid item xl={5} lg={4} sm={6} xs={12}>
                            <FormControl fullWidth size="small">
                                <FMSelectCustomer name="customerIds" />
                            </FormControl>
                        </Grid>
                        {(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer")) && (
                            <>
                                <Grid item xl={2} sm={6} xs={12} sx={{ minWidth: 140 }}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Month</InputLabel>
                                        <Select

                                            value={monthRef.current}
                                            onChange={handleExportMonthChange}
                                            label="Month"
                                            IconComponent={ExpandMoreIcon}
                                            sx={{
                                                borderRadius: '8px',
                                                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#0000003b' },
                                            }}
                                        >
                                            <MenuItem value="1">January</MenuItem>
                                            <MenuItem value="2">February</MenuItem>
                                            <MenuItem value="3">March</MenuItem>
                                            <MenuItem value="4">April</MenuItem>
                                            <MenuItem value="5">May</MenuItem>
                                            <MenuItem value="6">June</MenuItem>
                                            <MenuItem value="7">July</MenuItem>
                                            <MenuItem value="8">August</MenuItem>
                                            <MenuItem value="9">September</MenuItem>
                                            <MenuItem value="10">October</MenuItem>
                                            <MenuItem value="11">November</MenuItem>
                                            <MenuItem value="12">December</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xl={2} sm={6} xs={12} sx={{ minWidth: 120 }}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Year</InputLabel>
                                        <Select

                                            value={yearRef.current}
                                            onChange={handleExportYearChange}
                                            label="Year"
                                            IconComponent={ExpandMoreIcon}
                                            sx={{
                                                borderRadius: '8px',
                                                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#0000003b' },
                                            }}
                                        >
                                            {Array.from({ length: 10 }, (_, i) => {
                                                const year = new Date().getFullYear() - 5 + i;
                                                return (
                                                    <MenuItem key={year} value={year.toString()}>
                                                        {year}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </>
                        )}
                </Grid>
            </Box>
        </LocalizationProvider>
        {openCompletedDialog && <DiligentMarkCompleted
                open={!!openCompletedDialog}
                handleClose={handleCloseCompletedDialog}
                handleSubmit={handleSubmitCompletedDialog}
                selectedRows={selectedRows}
            />}
            <Box
                position="relative"
                sx={{
                    minHeight: 400,
                    width: "100%",
                }}
            >
                {loading && (
                    <Box
                        position="absolute"
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                            backgroundColor: "rgba(250, 251, 252, 0.85)",
                            zIndex: 10,
                            border: "1px solid #e2e8f0",
                            borderRadius: 1,
                        }}
                    >
                        <Box sx={{ width: "100%", maxWidth: 320 }}>
                            <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                            <Box sx={{ mt: 1.5, textAlign: "center" }}>
                                <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                            </Box>
                        </Box>
                    </Box>
                )}
                <DiligentSearchList
                    ReportModuleCL={ReportModule}
                    fetchDataMain={fetchNewData}
                    tabValue={tabValue}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    _currentPage={_currentPage}
                    setCurrentPage={setCurrentPage}
                    _pageSize={_pageSize}
                    setPageSize={setPageSize}
                    sortRef={sortRef}
                    filterRef={filterRef}
                    fetchAllRowsForExport={fetchAllDiligentSearchRowsForExport}
                />
            </Box>
        </>
    );
}
